
import Vue from "vue";
import { Alert } from "@/commons/types";
import Alerter from "@/components/Alerter.vue";
import { OpenAPI } from "@/commons/client";
import { AuthService, Body_login_v1_auth_token__post } from "@/commons/client";

export default Vue.extend({
  name: "Login",

  components: {
    Alerter,
  },

  data: () => ({
    loginData: {} as Body_login_v1_auth_token__post,
    passwordIsClear: false,
    alerts: [] as Alert[],
  }),

  computed: {
    rules() {
      /**********************
       * Get rules from store
       **********************/
      return this.$store.state.genericRules;
    },
    maxCardWidth() {
      /*************************************
       * Return tthe right card length based on
       * current breakpoint.
       *************************************/
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
          return 400;
      }
      return 550;
    },
  },

  methods: {
    showHidePassword() {
      this.passwordIsClear = !this.passwordIsClear;
    },
    async doLogin() {
      /**********************
       * Do login
       **********************/
      try {
        const res = await AuthService.loginV1AuthTokenPost(this.loginData);
        OpenAPI.TOKEN = res.access_token;
        this.$store.dispatch("login", res.access_token);
        this.$router.push({ name: "home" });
      } catch (error: unknown) {
        console.error("Login error:", error);
        const err = error as {
          response?: { status?: number; data?: { detail?: string } };
        };

        const status = err.response?.status;
        const detail = err.response?.data?.detail;

        if (status === 403 && detail === "Access not allowed at this time") {
          this.alerts.push({
            type: "warning",
            text: "Accesso negato: puoi accedere solo durante gli orari consentiti.",
          });
        } else if (status === 400) {
          this.alerts.push({
            type: "error",
            text: "Credenziali non valide",
          });
        } else {
          this.alerts.push({
            type: "error",
            text: "Errore in fase di login",
          });
        }
      }
    },
  },
});
